import {IThumbnaiProvider} from "./config";
import {FileBlobPromises} from "./fileBlobPromises";

export class ThumbnailProvider implements IThumbnaiProvider {
  getDataUrl(file: File){
    return FileBlobPromises.readAsDataURL(file)
  }
}
